// Jokes side content
export const jokesArr = [
  "Type in a topic sentence between 5 and 25 words long.",
  "Click “Get Witscript’s responses.”",
  "Witscript responds with some suggested jokes and picks its favorite.",
  "Click again for more responses to the same sentence. Or enter a new sentence.",
];
